import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

const COPY_CONFIG = {
  header: { defaultValue: '', isTypeSpecific: true },
  description: { defaultValue: [], isTypeSpecific: true },
  disclaimer: { defaultValue: [], isTypeSpecific: false },
  skipButtonText: { defaultValue: '', isTypeSpecific: false },
  submitButtonText: { defaultValue: '', isTypeSpecific: false },
  errorMessage: { defaultValue: '', isTypeSpecific: false },
  generalErrorMessage: { defaultValue: '', isTypeSpecific: true },
  inputPlaceholder: { defaultValue: '', isTypeSpecific: false },
  useCloseButton: { defaultValue: false, isTypeSpecific: true },
  subscribeButton: { defaultValue: '', isTypeSpecific: true },
  emailPrefill: { defaultValue: false, isTypeSpecific: true },
  allowAccountEmailUse: { defaultValue: false, isTypeSpecific: true },
  preventRequiredDomainsUse: { defaultValue: false, isTypeSpecific: true },
};

export const resolvePageCopy = ({ subscriptionModal, siteCopy, type }) => {
  const useOverride = type === 'sign-up' && !_isEmpty(subscriptionModal);

  const finalCopy = Object.keys(COPY_CONFIG).reduce((acc, key) => {
    const { defaultValue, isTypeSpecific } = COPY_CONFIG[key];

    if (useOverride) {
      acc[key] = _get(subscriptionModal, key, defaultValue);
    } else {
      const fallbackSource = _get(siteCopy, 'pageCopy', {});
      const relevantFallbackSource = isTypeSpecific
        ? _get(fallbackSource, type, {})
        : fallbackSource;

      acc[key] = _get(relevantFallbackSource, key, defaultValue);
    }

    return acc;
  }, {});

  return finalCopy;
};
